import { apiUrls, routeMappings, SessionStore } from '../../constants';
import axios from '../../common/utils/interceptor';
import { getDisplayOptionsStatus } from './getDisplayOptionsStatus';
import { ValidateAssessmentLaunchConfig } from '../../assessment/interfaces';
import { ExperienceURL, SHLApp } from '../../constants/shlapp';
import { validateAssessmentLaunchUrl } from '../../common/utils/validateAssessmentLaunchUrl';
import { setCookie } from '../../common/utils/cookies';
import { User } from '../../store/interfaces';
import { getStore } from '../../store';

declare global {
  interface Window {
    Android: {
      startAmcatApp: (url: string) => void;
    };
    webkit: {
      messageHandlers: {
        startAmcat: {
          postMessage: (url: string, locationURL: string) => void;
        };
      };
    };
  }
}

window.Android = window.Android || {};
window.webkit = window.webkit || {};

const isSHLAppAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_AGENT) > -1;
const isSHLAndroidAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_ANDROID_AGENT) > -1;
const isSHLIOSAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_IOS_AGENT) > -1;

const fnAndroid = (data: { url: string }): boolean => {
  if (typeof window.Android.startAmcatApp === 'function') {
    window.Android.startAmcatApp(data.url);
    return true;
  }
  return false;
};

const fniOS = (data: { url: string }): boolean => {
  const content = window.webkit;
  if (typeof content.messageHandlers.startAmcat.postMessage === 'function') {
    content.messageHandlers.startAmcat.postMessage(data.url, window.location.origin);
    return true;
  }
  return false;
};

export const getAssessmentUrlApp = async (
  launchAssessmentConfig: ValidateAssessmentLaunchConfig,
  candidate: User,
): Promise<boolean> => {
  const isMobileApp = launchAssessmentConfig?.displayOptions
    ? getDisplayOptionsStatus(launchAssessmentConfig.displayOptions)
    : false;

  const { activeComponentId, projectId, sittingId, packageId, selectedLanguageCode, itemId, taskId } =
    launchAssessmentConfig;

  const request = {
    instructionShown: false,
    componentId: activeComponentId,
    isPractice: false,
    isWarmup: false,
    projectId: projectId,
    lang: selectedLanguageCode,
    sittingId: sittingId !== null ? sittingId : 0,
    packageId: packageId,
  };

  try {
    if (isMobileApp && isSHLAppAgent) {
      // Multiple axios call for validating first and then /mobile/start to redirect either to
      // Android or IOS
      const response = await validateAssessmentLaunchUrl(launchAssessmentConfig);

      if (!response.error) {
        const { data } = await axios.post(apiUrls.APP_MOBILE_START, request);
        sessionStorage.setItem(SessionStore.isEntryExhausted, data?.entryExhausted);

        if (!data.entryExhausted) {
          const workflowSession = getStore().state.workflowSession;

          if (workflowSession) {
            const candidateId = workflowSession.candidateId || (candidate && candidate.candidateId);
            const scoreEvaluationURL = `${routeMappings['TASK']}/${taskId}${routeMappings['EXPASSES']}/${itemId}${routeMappings['ASSESSMENT_EVALUATION']}`;
            const scoreEvaluationKey = `${candidateId}_${ExperienceURL.SCORE_EVALUATION_URL}`;

            const cookieObj = { [scoreEvaluationKey]: scoreEvaluationURL };
            setCookie('experience_url', JSON.stringify(cookieObj));
          }

          return isSHLAndroidAgent ? fnAndroid(data) : isSHLIOSAgent ? fniOS(data) : false;
        } else {
          return false;
        }
      }
    }
    return false;
  } catch (e) {
    console.error('Error in mobile start', e);
    return e;
  }
};
